module.exports = __webpack_public_path__ + "img/首页_02.8f347a66.jpg";